import { objectTypes } from '../../constants/types';
import { assignValueToAllObjectKeys } from '../../utils/helpers';
export const GET_ASSOCIATION_SECTION_LIST = 'GET_ASSOCIATION_SECTION_LIST';
export const SET_ASSOCIATIONS = 'SET_ASSOCIATIONS';
export const ASSOCIATE_OBJECTS = 'ASSOCIATE_OBJECTS';
export const TOGGLE_LOADING = 'TOGGLE_LOADING';
export const DISASSOCIATE_OBJECT = 'DISASSOCIATE_OBJECT';
export const DISASSOCIATE_OBJECT_FULFILLED = 'DISASSOCIATE_OBJECT_FULFILLED';
export const SET_CRM_OBJECT_TYPE = 'SET_CRM_OBJECT_TYPE';
export const GET_ASSOCIATED_OBJECTS = 'GET_ASSOCIATED_OBJECS';
export const SET_ASSOCIATED_OBJECTS = 'SET_ASSOCIATED_OBJECTS';
export const SET_CREATED_OBJECT = 'SET_CREATED_OBJECT';
export const UPDATE_ACCOSIATED_OBJECT = 'UPDATE_ACCOSIATED_OBJECT';
export const initialState = {
  isLoading: false,
  associations: {},
  associatedObjects: assignValueToAllObjectKeys(objectTypes, {}),
  crmObjectType: 'contact'
};
export const reducer = (state, action) => {
  switch (action.type) {
    case SET_ASSOCIATIONS:
      return Object.assign({}, state, {
        isLoading: false,
        associations: Object.assign({}, state.associations, {
          [action.payload.type]: action.payload.list
        })
      });
    case TOGGLE_LOADING:
      return Object.assign({}, state, {
        isLoading: action.payload
      });
    case DISASSOCIATE_OBJECT_FULFILLED:
      {
        const objects = [...state.associations[action.payload.objectType]];
        return Object.assign({}, state, {
          associations: Object.assign({}, state.associations, {
            [action.payload.objectType]: objects.filter(el => el.id !== action.payload.objectId)
          })
        });
      }
    case SET_CRM_OBJECT_TYPE:
      return Object.assign({}, state, {
        crmObjectType: action.payload
      });
    case SET_ASSOCIATED_OBJECTS:
      {
        const existingObjects = Object.assign({}, state.associatedObjects[action.payload.type]);
        action.payload.list.forEach(entity => {
          existingObjects[entity.id] = entity;
        });
        return Object.assign({}, state, {
          associatedObjects: Object.assign({}, state.associatedObjects, {
            [action.payload.type]: Object.assign({}, existingObjects)
          })
        });
      }
    case SET_CREATED_OBJECT:
      return Object.assign({}, state, {
        associatedObjects: Object.assign({}, state.associatedObjects, {
          [action.payload.type]: Object.assign({}, state.associatedObjects[action.payload.type], {
            [action.payload.entity.id]: action.payload.entity
          })
        })
      });
    case UPDATE_ACCOSIATED_OBJECT:
      {
        const entityToUpdate = state.associatedObjects[action.payload.type][action.payload.objectId];
        if (entityToUpdate) {
          return Object.assign({}, state, {
            associatedObjects: Object.assign({}, state.associatedObjects, {
              [action.payload.type]: Object.assign({}, state.associatedObjects[action.payload.type], {
                [action.payload.objectId]: Object.assign({}, entityToUpdate, {
                  properties: Object.assign({}, entityToUpdate.properties, action.payload.data)
                })
              })
            })
          });
        }
        return state;
      }
    default:
      return state;
  }
};